import React, {useEffect, useState} from 'react';
import './AdminSupervision.scss';
import _axios from "../../../../httpService";
import {prefixUrl} from "../../../../utils/utilsData";
import {toast} from "react-toastify";
import Loader from "../../../Loader";
import ChartsSide from "./SupervisionItems/ChartsSide";
import TableTasks from "./SupervisionItems/TableTasks";
import CircleProgressbarReport from "./SupervisionItems/CircleProgressbarReport";
import GanttChart from "./SupervisionItems/GanttChart";
import GanttChartTwo from "./SupervisionItems/GanttChartTwo";

const AdminSupervision = () => {

  const [initialData, setInitialData] = useState({});
  const [isLoad, setIsLoad] = useState(false);

  useEffect(() => {
    _axios.get(prefixUrl() + "/arkaMonitoring/?request=managerMonitoringData").then((response) => {
      if (response.data.status) {
        setInitialData(response.data.data);
        setIsLoad(true)
      } else {
        toast.error(response.data.message);
      }
    })
  }, []);

  return (
    <>
      {isLoad ?
        <section className="AdminSupervision">
          <ChartsSide data={initialData}/>
          <TableTasks data={initialData?.delayedTaskList}/>
          <CircleProgressbarReport data={initialData?.reportsCharts}/>
          <GanttChart data={initialData?.taskGanttChart}
                      projects={initialData?.projectsList}
                      DefaultValues={initialData?.taskGanttChartDefaultValue}/>
          <GanttChartTwo data={initialData?.phaseGanttChart}
                         projects={initialData?.projectsList}
                         DefaultValues={initialData?.taskGanttChartDefaultValue}/>
        </section> : <Loader/>}
    </>
  );
};

export default AdminSupervision;